import React from 'react';

const HeroSection = ({ onNavigate }) => {
    return (
      <>
    <section  className="hero-section">
      {/* Overlay */}
      <div className="overlay" />

      <div className="relative z-10 flex h-full items-center justify-center px-4 sm:px-8">
        <div className="text-center text-white max-w-2xl">
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-4 drop-shadow-lg">
       אפרת - STYLE UP
                <br></br>
                <span className="text-pink-400">ללבוש את הסיפור שלך</span>
          </h1>
          <p className="text-lg md:text-2xl mb-8 text-gray-200">
           
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a onClick={() => onNavigate('workshops')} style={{cursor: 'pointer'}} className="px-8 py-3 bg-pink-500 hover:bg-pink-600 transition rounded-full font-semibold shadow-lg">
            לסדנאות והרצאות
            </a>
            <a onClick={() => onNavigate('contact')} style={{cursor: 'pointer'}}  className="px-8 py-3 bg-transparent border border-white hover:bg-white hover:text-black transition rounded-full font-semibold">
              ליצירת קשר
            </a>
          </div>
        </div>
      </div>
      </section>

            </>
  );
};

export default HeroSection;
